module.exports = __webpack_public_path__ + "media/images/mission_bg_3-95e34b9a82c26dac431e0b382dba99da.svg";